import axios from "axios";
import config from "./config";

// Mirrors the FROZEN §3 contract in the FT-1189 spec
// (yuso-portals-backend GET /api/v1/contracts/status) — do not reshape here.

export type StatusDirection = "injection" | "offtake" | "flex";

export interface ContractStatusRenewal {
  start_date: string;
  signed: boolean;
}

export interface ContractStatusContract {
  contract_id: number;
  status: string;
  signature_date: string | null;
  start_date: string | null;
  commencement_date: string | null;
  end_date: string | null;
}

export interface SdpStatusEntry {
  ean: string | null;
  direction: StatusDirection;
  installation_id: string;
  display_status: string | null;
  renewal: ContractStatusRenewal | null;
  data_flags: string[];
  contracts: ContractStatusContract[];
}

export async function fetchContractStatuses(
  companyId: number,
  direction: StatusDirection,
  token: string,
): Promise<SdpStatusEntry[]> {
  const { data } = await axios.get<{ sdps: SdpStatusEntry[] }>(
    `${config.API_SERVICES}/api/v1/contracts/status`,
    {
      params: { company_id: companyId, direction },
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return data.sdps;
}
